import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => {
  return ({
    container: {
      height: 'auto',
      backgroundColor: theme.palette.primary.main,
      color: 'white',
    },
    headerContent: {
      minHeight: '57px'
    },
    headerText: {
      fontSize: '14px',
      fontWeight: 'bold'
    },
    logoImage: {
      height: '28px',
      width: '28px',
      margin: '10px'
    },
    pointer: {
      cursor: 'pointer'
    },
    avatar: {
      backgroundColor: 'transparent',
      marginRight: '10px',
      width: '30px',
      height: '30px',
      verticalAlign: 'middle'
    },
    avatarText: {
      fontSize: '14px',
    },
    popoverText: {
      fontSize: '16px',
      color: '#707070',
      fontWeight: 600,
      padding: '10px 5px',
      textAlign: 'center',
      wordBreak: 'break-all'
    },
    typography: {
      padding: `${theme.spacing(0.5)} ${theme.spacing(1)}`,
      cursor: 'pointer',
      fontSize: '15px',
      color: '#6F6F6F'
    },
    linkStyle: {
      textDecoration: 'none',
      color: '#6F6F6F'
    },
    headerPaper: {
      minWidth: 200,
      maxWidth: 300,
      textOverflow: 'ellipsis',
      overflow: 'hidden'
    }
  })
})

export { useStyles }
